import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-4 column items-center q-px-xs" }
const _hoisted_2 = { class: "primary-underlined row justify-between items-end" }
const _hoisted_3 = { class: "bg-primary title-underlined q-px-sm q-py-xs" }
const _hoisted_4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: "{1.5}",
  stroke: "currentColor",
  style: {"width":"18px"},
  class: "q-ml-sm"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "bg-white q-px-sm q-py-xs",
  style: {"height":"100%"}
}
const _hoisted_8 = { class: "text-primary text-subtitle1 text-bold ellipsis" }
const _hoisted_9 = {
  key: 0,
  class: "text-secondary row items-center ellipsis q-mb-sm"
}
const _hoisted_10 = { class: "col-6 text-subtitle1 text-bold" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = {
  key: 1,
  class: "text-secondary ellipsis text-bold"
}
const _hoisted_13 = {
  key: 2,
  class: "text-secondary row items-center ellipsis q-mb-sm"
}
const _hoisted_14 = { class: "col-6 text-subtitle1 text-bold" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "text-secondary row items-center ellipsis" }
const _hoisted_17 = { class: "col-6 text-subtitle1 text-bold" }
const _hoisted_18 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Osmolarity.Additives.Title')), 1),
      _createVNode(_component_q_btn, {
        "no-caps": "",
        flat: "",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('reset-form')),
        class: "text-secondary text-caption"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('Reset')), 1),
          (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle([{"width":"100%"}, !_ctx.mobile ? 'max-height: 1000px; overflow-y: auto' : '']),
      class: "col q-py-xs"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSolutions, (solution, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "bg-grey q-mb-xs q-pa-md",
          style: _normalizeStyle(solution.id === 'free' ? 'height: 250px' : 'height: 205px')
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(solution.title), 1),
            _createElementVNode("div", {
              class: "text-subtitle2 ellipsis-3-lines",
              style: _normalizeStyle(solution.id === 'free' ? 'height: 40px' : 'height: 70px')
            }, _toDisplayString(solution.description), 5),
            (solution.id === 'free')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Osmolarity.Free.Name')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_q_input, {
                      debounce: "1000",
                      modelValue: solution.title,
                      "onUpdate:modelValue": ($event: any) => ((solution.title) = $event),
                      dense: "",
                      outlined: "",
                      square: "",
                      onChange: () => solution.title = solution.title ? solution.title : _ctx.$t('Osmolarity.Free.Title')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (solution.id !== 'free')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('Osmolarity.Free.Osmolarity')) + " " + _toDisplayString(solution.baseOsmo) + " mosm/l", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('Osmolarity.Free.Osmolarity')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_q_input, {
                      debounce: "1000",
                      modelValue: solution.baseOsmo,
                      "onUpdate:modelValue": ($event: any) => ((solution.baseOsmo) = $event),
                      modelModifiers: { number: true },
                      onChange: (value) => {
                                    if (isNaN(value) || !value) {
                                        solution.baseOsmo = 0;
                                    } else {
                                        solution.baseOsmo = solution.baseOsmo < 0 ? 0 : solution.baseOsmo
                                    }
                                },
                      dense: "",
                      outlined: "",
                      square: "",
                      suffix: "mosm/l"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ])
                ])),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('Osmolarity.Free.Volume')), 1),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_q_input, {
                  debounce: "1000",
                  modelValue: solution.quantity,
                  "onUpdate:modelValue": ($event: any) => ((solution.quantity) = $event),
                  modelModifiers: { number: true },
                  onChange: (value) => {
                                    if (isNaN(value) || !value) {
                                        solution.quantity = 0;
                                    } else {
                                        solution.quantity = solution.quantity < 0 ? 0 : solution.quantity
                                    }
                                },
                  dense: "",
                  outlined: "",
                  square: "",
                  suffix: "ml"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ])
            ])
          ])
        ], 4))
      }), 128))
    ], 4)
  ]))
}